import React from 'react';
// import { useMemo } from 'react';

// import { 
//   Chart as CharJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler
// } from "chart.js";
// import {Line} from "react-chartjs-2";

// CharJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler
// );

// const scores = [4, 6, 3, 7, 5, 4, 8, 3, 9];
// const scores2 = [1, "", 4, 2, 6, "", 1, 5, 6];
// // const labels = [100, 200, 300, 400, 500, 600, 700, 800, 900];
// const labels = ['2022-02-19', '2022-03-14', '2022-04-21', '2022-05-08', '2022-07-11', '2022-08-14', '2022-09-05', '2022-09-24', '2022-10-01'];

// const options = {
//   fill: false,
//   responsive: true,
//   scales: {
//     y: {
//       min: 0,
//     },
//     // xAxes: {
//     //   type: "time",
//     // }
//   },
//   Plugins: {
//     legend: {
//       display: true,
//     }
//   }

// };

const HomeLab2 = props => {
  // const data = useMemo(function(){
    return (
    // return {
  //     datasets: [
  //       {
  //         label: 'Mis datos',
  //         data: scores,
  //         tension: 0.3,
  //         borderColor: "rgb(75, 192, 192)",
  //         pointRadius: 6,
  //         // pointBackgroundColor: "rgb(75, 192, 192)",
  //         pointBackgroundColor: function(context) {
  //           var index = context.dataIndex;
  //           var value = context.dataset.data[index];
  //           if (value > 6) {
  //               return 'red'                    
  //           }else{
  //             if (value > 3) {
  //               return 'yellow'                    
  //             }else{
  //               return 'green'
  //             }
  //           }
  //         },
  //         // backgroundColor: "rgb(75, 192, 192, 0.3)",

  //       },
  //       {
  //         label: 'Mis datos 2',
  //         data: scores2,
  //         tension: 0.3,
  //         borderColor: "green",
  //         pointRadius: 6,
  //         // pointBackgroundColor: "green",
  //         pointBackgroundColor: function(context) {
  //           var index = context.dataIndex;
  //           var value = context.dataset.data[index];
  //           if (value > 6) {
  //             return 'red'                    
  //           }else{
  //             if (value > 3) {
  //               return 'yellow'                    
  //             }else{
  //               return 'green'
  //             }
  //           }
  //         },
  //         // backgroundColor: "rgb(0, 255, 0, 0.3)",

  //       }
  //     ],
  //     labels
  //   };
  // },[]);

  // return <Line data={data} options={options} />;
  <div>

    </div>
  )
}
 
export default HomeLab2